import type { FaireProductEntity } from "../../entity_types/product";

export const p_vku86j73uh: FaireProductEntity = {
  token: "p_vku86j73uh",
  type: "product",
  name: "Shampoo Bar | Cedar + Patchouli | Zero Waste Hair Care",
  brandToken: "b_7epwzqn7do",
  brandName: "Zero Waste MVMT",
  imageUrl:
    "https://cdn.faire.com/fastly/cde7d07ac1f415580d4a67b741b4bcc738beaac2e9d50232d622629519ed77af.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/822bad94cf4ee3eca693cde1844236858b19091d13c141e57f79f45227d839a0.png",
    "https://cdn.faire.com/fastly/47c9fad0fee4ab33d53fe35be9bf0a8f82bb8328a5b978e4d2b132c3b2665607.jpeg",
    "https://cdn.faire.com/fastly/3b193a909173b53bc883027f7cf4dad950dd5b61874ea64d4f01b0841a0454e0.jpeg",
    "https://cdn.faire.com/fastly/668e89d727fbe837dc597e871bb23d04e923af79e88d1036d0100cd594ff850f.jpeg",
    "https://cdn.faire.com/fastly/95e40b67ca7db90214bd99fa866ac060cd122f39ce5b00f889a1f8fc0ce9483b.jpeg",
    "https://cdn.faire.com/fastly/933eb6229901679ba6f71095602beb1178ae09795e15ea007c11182180c82595.jpeg",
    "https://cdn.faire.com/fastly/455a2fcef44c0b0fe1464e4f42ba60646db2879a4001a3e0833d48561bef3ace.jpeg",
  ],
  priceDollars: 9.75,
  description:
    "Our Cedar + Patchouli Shampoo Bar is crafted for those seeking a deep, soothing cleanse with an earthy, long-lasting scent—all in a zero-waste, plastic-free form. This bar blends the rich, grounding aroma of cedarwood with the exotic, slightly sweet musk of patchouli, creating a fragrance that transports you to a tranquil forest.\n\nEnriched with coconut oil and cocoa butter, this shampoo bar gently cleanses while hydrating and adding natural shine, leaving hair soft and balanced. Perfect for eco-conscious routines, this bar transforms your hair care experience into a sensory escape.\n\n🌱 Just 1 shampoo bar can replace up to 3-250ml bottles of shampoo and last for 50-75+ washes\n\nABOUT ZERO WASTE MVMT\n\nZero Waste MVMT is an eco-conscious brand on a mission to help you live more sustainably with plastic-free reusables and natural, earth-friendly products 🌱  We always ship plastic-free in recycled cardboard boxes and sealed with paper tape. All deliveries are carbon neutral 🌎",
  tags: [],
  msrpDollars: 19.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:58.754Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
